import React from 'react';
import classNames from 'classnames';
import BaseComponent from 'apps/new-web/views/component';
import DesktopHeader from './desktop-header';
import MobileHeader from './mobile-header';

export class PostLoginNavigation extends BaseComponent {
  render() {
    const { user, subNavComponent, assumedUserId } = this.props;
    return (
      <div>
        {user &&
          <nav
            className={ classNames('post-login-nav-component', {
              'with-sub-nav': subNavComponent
            }) }
          >
            <DesktopHeader user={ user } assumedUserId={ assumedUserId } />
            <MobileHeader user={ user } />
            {subNavComponent}
          </nav>
        }
      </div>
    );
  }
}

export default PostLoginNavigation;
